import type { ApiClient } from '../client';

// The «Bloquear» WRITE: change the account state and nothing else. It does NOT anonymize — the
// account keeps its name, phone, email, address and device, and its «Entregas» stay readable —
// which is the whole difference from `deleteUser` beside it.
//
// A «Usuario» account is blocked with no body at all: the id in the path is the entire request, so
// nothing personal can reach a request log. A courier account carries the agent's reason, and only
// in the body — it is free text, and a path ends up in access logs. The client attaches the
// Firebase token via the Authorization header.
//
// Empty 200 — nothing to parse and nothing for Zod to validate: the caller refetches the account
// and the repainted ficha, with its chip turned red and the action gone, IS the acknowledgement.
export async function blockUser(client: ApiClient, id: string, reason?: string): Promise<void> {
  const path = `/app_service/panel/v1/users/${encodeURIComponent(id)}/block`;
  await (reason === undefined ? client.post(path) : client.post(path, { reason }));
}
